import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TipoParteLocalListaComponent } from './tipo-parte-local-lista/tipo-parte-local-lista.component';

const routes: Routes = [
  { path: 'tipoParteLocal/listar', component: TipoParteLocalListaComponent, data: { titulo: 'Lista os Tipo de Parte' }  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipoParteLocalRoutingModule { }
